import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Which exchange recommendation experience this customer gets. LaunchDarkly
 * owns both the rollout and the split, so the client never decides.
 */
export const getExchangeRecommendationPresentation = unaryRpc({
  name: "getExchangeRecommendationPresentation" as const,
  input: z.object({ draftReturnId: zExt.objectId() }),
  output: z.object({ presentation: z.enum(["off", "popup", "page"]) }),
});
